module.exports = __webpack_public_path__ + "static/media/Oct10-17.4af910be.png";